import {render} from 'react-dom';
import App from 'react/App/App.js';

render(App, document.getElementById('root'));